module.exports = __webpack_public_path__ + "static/media/faucet-drip.502d0881.svg";